"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetadataField = exports.DisplayType = exports.Visibility = exports.Network = exports.Chain = void 0;
var Chain;
exports.Chain = Chain;

(function (Chain) {
  Chain["near"] = "near";
})(Chain || (exports.Chain = Chain = {}));

var Network;
exports.Network = Network;

(function (Network) {
  Network["mainnet"] = "mainnet";
  Network["testnet"] = "testnet";
})(Network || (exports.Network = Network = {}));

var Visibility;
exports.Visibility = Visibility;

(function (Visibility) {
  Visibility["nsfw"] = "nsfw";
  Visibility["safe"] = "safe";
})(Visibility || (exports.Visibility = Visibility = {}));

var DisplayType;
exports.DisplayType = DisplayType;

(function (DisplayType) {
  DisplayType["boostNumber"] = "boost_number";
  DisplayType["boostPercentage"] = "boost_percentage";
  DisplayType["number"] = "number";
  DisplayType["date"] = "date";
  DisplayType["location"] = "location";
  DisplayType["website"] = "website";
  DisplayType["zoom"] = "zoom";
  DisplayType["placeId"] = "place_id";
  DisplayType["rarity"] = "rarity";
  DisplayType["youtubeUrl"] = "youtube_url";
  DisplayType["latitude"] = "latitude";
  DisplayType["longitude"] = "longitude";
})(DisplayType || (exports.DisplayType = DisplayType = {}));

var MetadataField;
exports.MetadataField = MetadataField;

(function (MetadataField) {
  MetadataField["Id"] = "id";
  MetadataField["Title"] = "title";
  MetadataField["Category"] = "category";
  MetadataField["Description"] = "description";
  MetadataField["Media"] = "media";
  MetadataField["Media_hash"] = "media_hash";
  MetadataField["Tags"] = "tags";
  MetadataField["Image_preview"] = "imagePreview";
  MetadataField["Copies"] = "copies";
  MetadataField["Extra"] = "extra";
  MetadataField["External_url"] = "external_url";
  MetadataField["Background_color"] = "background_color";
  MetadataField["Animation_url"] = "animation_url";
  MetadataField["Animation_hash"] = "animation_hash";
  MetadataField["Youtube_url"] = "youtube_url";
  MetadataField["UpdatedAt"] = "updated_at";
  MetadataField["Document"] = "document";
  MetadataField["Document_hash"] = "document_hash";
  MetadataField["Lock"] = "lock";
  MetadataField["Visibility"] = "visibility";
  MetadataField["Chain"] = "chain";
  MetadataField["Store"] = "store";
  MetadataField["Royalty"] = "royalty";
  MetadataField["Royalty_perc"] = "royalty_perc";
  MetadataField["SplitRevenue"] = "split_revenue";
})(MetadataField || (exports.MetadataField = MetadataField = {}));